const actionType = {

    GET_EMPLOYE_LIST_SUCCESS : "GET_EMPLOYE_LIST_SUCCESS",
    GET_EMPLOYE_LIST_FAILURE : "GET_EMPLOYE_LIST_FAILURE",
    ADD_EMPLOYE_SUCCESS : "ADD_EMPLOYE_SUCCESS",
    ADD_EMPLOYE_FAILURE : "ADD_EMPLOYE_FAILURE",
    GET_PAYMENT_RULES_SUCCESS : "GET_PAYMENT_RULES_SUCCESS",
    GET_PAYMENT_RULES_FAILURE: "GET_PAYMENT_RULES_FAILURE",
    EDIT_EMPLOYE_SUCCESS : "EDIT_EMPLOYE_SUCCESS",
    EDIT_EMPLOYE_FAILURE :"EDIT_EMPLOYE_FAILURE",
    DELETE_EMPLOYE_SUCCESS :"DELETE_EMPLOYE_SUCCESS",
    DELETE_EMPLOYE_FAILURE : "DELETE_EMPLOYE_FAILURE",
    SAVE_PAYMENT_RULE : "SAVE_PAYMENT_RULE",
    EDIT_PAYMENT_RULE_SUCCESS : "EDIT_PAYMENT_RULE_SUCCESS",
    EDIT_PAYMENT_RULE_FAILURE : "EDIT_PAYMENT_RULE_FAILURE",
    GET_APPROXIMATE_COST_SUCCESS : "GET_APPROXIMATE_COST_SUCCESS",
    GET_APPROXIMATE_COST_FAILURE : "GET_APPROXIMATE_COST_FAILURE",
    UPDATE_APPROXIMATE_COST_SUCCESS : "UPDATE_APPROXIMATE_COST_SUCCESS" ,
    UPDATE_APPROXIMATE_COST_FAILURE : "UPDATE_APPROXIMATE_COST_FAILURE",
    GET_BESTPERFORMANCE_SUCCESS: "GET_BESTPERFORMANCE_SUCCESS",
    GET_BESTPERFORMANCE_FAILURE: "GET_BESTPERFORMANCE_FAILURE",
    GET_REQUEST_STATUS_LIST_SUCCESS:"GET_REQUEST_STATUS_LIST_SUCCESS",
    GET_REQUEST_STATUS_LIST_FAILURE:"GET_REQUEST_STATUS_LIST_FAILURE",
    REVENUE_REPORT_SUCCESS :"REVENUE_REPORT_SUCCESS",
    REVENUE_REPORT_FAILURE :"REVENUE_REPORT_FAILURE ",
    FAXEDPAGE_REPORT_SUCCESS :"FAXEDPAGE_REPORT_SUCCESS",
    FAXEDPAGE_REPORT_FAILURE :"FAXEDPAGE_REPORT_FAILURE ",
    AVERAGE_REPORT_SUCCESS :  "AVERAGE_REPORT_SUCCESS",
    AVERAGE_REPORT_FAILURE :  "AVERAGE_REPORT_FAILURE ",
    COMPLETED_REPORT_SUCCESS :"COMPLETED_REPORT_SUCCESS",
    COMPLETED_REPORT_FAILURE :"COMPLETED_REPORT_FAILURE ",
    FACILITY_REPORT_SUCCESS :"FACILITY_REPORT_SUCCESS",
    FACILITY_REPORT_FAILURE :"FACILITY_REPORT_FAILURE ",
    PRACTITIONER_REPORT_SUCCESS :"PRACTITIONER_REPORT_SUCCESS",
    PRACTITIONER_REPORT_FAILURE :"PRACTITIONER_REPORT_FAILURE ",
    GET_HEDIS_FLAT_SUCCESS : "GET_HEDIS_FLAT_SUCCESS",
    GET_HEDIS_FLAT_FAILURE : "GET_HEDIS_FLAT_FAILURE",
    UPDATE_HEDIS_FLAT_SUCCESS : "UPDATE_HEDIS_FLAT_SUCCESS" ,
    UPDATE_HEDIS_FLAT_FAILURE : "UPDATE_HEDIS_FLAT_FAILURE",
    DELETE_UNPROCESSED_REQUEST_SUCCESS : "DELETE_UNPROCESSED_REQUEST_SUCCESS",
    DELETE_UNPROCESSED_REQUEST_FAILURE :"DELETE_UNPROCESSED_REQUEST_FAILURE",
    GET_MONTHLY_REQUEST_LIST_SUCCESS :"GET_MONTHLY_REQUEST_LIST_SUCCESS",
    GET_MONTHLY_REQUEST_LIST_FAILURE :"GET_MONTHLY_REQUEST_LIST_FAILURE",
    DELETE_REQUESTED_PRACTICE_SUCCESS : "DELETE_REQUESTED_PRACTICE_SUCCESS",
    DELETE_REQUESTED_PRACTICE_FAILURE : "DELETE_REQUESTED_PRACTICE_FAILURE",

  };
  export default actionType;
    